import { nextTick, ref } from 'vue'
import store from '/@/store'
import * as Cesium from 'cesium'
import PanoramicPhotos from '/@/assets/icons/panoramicPhotos.svg'
import { state, viewer } from './use-cesium-map'
import { getMapMediaFiles } from '/@/api/media'
import { point, destination } from '/@/utils/geo.js'

export const imageList = ref([])
let Fun
export const showImageModal = ref(false)
export const panoramaUrl = ref('')
export const currentIndex = ref(0)
export const currentMediaList = ref([])
export const currentMedia = ref({})
const mapMediaType = { 1: 'JiePing', 2: 'GuangJiao', 3: 'HongWai', 4: 'BianJiao', 5: 'KeJianGuangGuangJiao', 12: 'QuanJing360', QuanJing360: 12, JiePing: 1, GuangJiao: 2, HongWai: 3, BianJiao: 4, KeJianGuangGuangJiao: 5 }
const mapMediaIcon = { QuanJing360: '360', JiePing: 'S', GuangJiao: 'W', HongWai: 'IR', BianJiao: 'Z', KeJianGuangGuangJiao: 'V' }
function getSubFileTypeLetter (string) {
  switch (string) {
    case mapMediaType.BianJiao:
      return mapMediaIcon.BianJiao
    case mapMediaType.GuangJiao:
      return mapMediaIcon.GuangJiao
    case mapMediaType.HongWai:
      return mapMediaIcon.HongWai
    case mapMediaType.JiePing:
      return mapMediaIcon.JiePing
    case mapMediaType.KeJianGuangGuangJiao:
      return mapMediaIcon.KeJianGuangGuangJiao
    case mapMediaType.QuanJing360:
      return mapMediaIcon.QuanJing360
  }
}
export function getImageMap () {
  return new Promise((resolve, reject) => {
    if (viewer._imageClick) {
      viewer._imageClick.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
      viewer._imageClick = null
    }
    getMapMediaFiles().then(res => {
      const list = []
      res.data.forEach(item => {
      // 根据新结构，每个 item 直接是一个文件对象
        const r = `files${item.id}` // 使用 parent_id 作为父级标识
        const u = {
          title: item.name,
          key: r,
          type: 'files',
          children: []
        }

        // 根据新结构，如果 item 有 children 数组，则处理子项
        if (item.children && item.children.length > 0) {
          item.children.forEach(a => {
            let f = ''
            // 假设全景图为 'photo360'，普通图为 'photo'，这里根据实际情况调整判断条件
            a.panorama ? f = 'photo360' : f = 'photo'
            u.children.push({
              title: a.name,
              key: `${a.id}`,
              type: f
            })
            // 如果子项有 visibility 属性且为 true，则添加到列表中
            // if (a.visibility) {
            const l = {
              oldPicId: a.id,
              picId: `photoSherePoint_${a.id}`,
              picName: a.name, // 使用 name 字段
              parentId: a.parent_id,
              subFileType: a.subFileType || '',
              subFileTypeLetter: getSubFileTypeLetter(a.subFileType),
              visibility: true,
              panorama: a.panorama,
              longitude: Number(a.lon),
              latitude: Number(a.lat),
              absoluteAltitude: 0, // 新结构中可能没有这个字段
              downloadUrl: a.url,
              previewUrl: a.url,
              thumbnailsUrl: a.url,
              url: a.url,
              height: a.height,
              width: a.width,
              shootTime: a.shootTime,
              size: a.size,
              parentFile: r
            }
            list.push(l)
          // }
          })
        } else {
        // 如果 item 没有 children，则 item 本身就是可显示的图片
        // 判断是否为图片类型，这里假设所有 jpeg/png 都是普通图片
          if (item.file_type && ['jpeg', 'jpg', 'png'].includes(item.file_type.toLowerCase())) {
            const l = {
              oldPicId: item.id,
              parentId: item.parent_id,
              picId: `photoSherePoint_${item.id}`,
              picName: item.name,
              panorama: item.panorama,
              subFileType: 'photo', // 默认为普通图片
              subFileTypeLetter: getSubFileTypeLetter('photo'),
              visibility: true, // 如果没有 visibility 字段，默认显示
              longitude: Number(item.lon),
              latitude: Number(item.lat),
              absoluteAltitude: 0, // 新结构中没有 absoluteAltitude
              downloadUrl: item.url,
              previewUrl: item.url,
              thumbnailsUrl: item.url,
              url: item.url,
              height: null, // 新结构中没有 height
              width: null, // 新结构中没有 width
              shootTime: null,
              size: null,
              parentFile: r
            }
            list.push(l)
          }
        }
      })

      store.commit('SET_MAP_PHOTO_INFO_LIST', list)
      list.forEach((item, index) => {
        imagePrint(viewer, item, index)
      })
      const imageClick = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
      imageClick.setInputAction(e => {
        if (state.currentType === 'PointLine' || state.currentType === 'PolygonPoint') return
        const pickedObject = viewer.scene.pick(e.position)
        if (Cesium.defined(pickedObject) && pickedObject.id) {
          const imageCurrent = store.state.mapPhotoInfoList.find(item => item.picId === pickedObject.id.id)
          if (imageCurrent) {
            setBigCurrent(viewer, pickedObject.id.id, imageCurrent)
          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
      viewer._imageClick = imageClick
      resolve(true)
    }).catch((err) => {
      reject(err)
    })
  })
}
export function imagePrint (viewer, row, index) {
  imageList.value.push(row.picId)
  const obj = row
  const height = obj.absoluteAltitude || viewer.scene.globe.getHeight(Cesium.Cartographic.fromDegrees(obj.longitude, obj.latitude)) || 200
  const item = store.state.mapPhotoInfoList[index]
  item.absoluteAltitude || (item.absoluteAltitude = height)
  const u = [obj.longitude, obj.latitude, height]
  viewer.entities.add({
    id: obj.picId,
    position: Cesium.Cartesian3.fromDegrees(u[0], u[1], u[2]),
    billboard: {
      image: PanoramicPhotos,
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      alignedAxis: Cesium.Cartesian3.ZERO,
      scaleByDistance: getClass('normal'),
      disableDepthTestDistance: 5e5,
      distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 5e5),
      heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
    }
  })
}

export async function setBigCurrent (viewer, id, current) {
  const entity = viewer.entities.getById(id)
  if (entity) {
    imageList.value.forEach(item => {
      const entitys = viewer.entities.getById(item)
      if (entitys) {
        entitys.billboard.scaleByDistance = getClass('normal')
      }
    })
    entity.billboard.scaleByDistance = getClass('big')
    currentMediaList.value = store.state.mapPhotoInfoList.filter(item => item.parentId === current.parentId)
    currentIndex.value = currentMediaList.value.findIndex(item => item.picId === id)
    showImageModal.value = true
    currentMedia.value = current
    await changeImageView(id)
    const dom = document.getElementById('photo-sphere-viewer-dialog')
    const postionNow = {
      lat: currentMedia.value.latitude,
      lng: currentMedia.value.longitude,
      alt: currentMedia.value.absoluteAltitude
    }
    if (Fun) viewer.scene.preRender.removeEventListener(Fun)
    setScenePreRender(dom, postionNow)
  }
}

export function setCurrent (index) {
  if (currentMediaList.value[index]) {
    const id = currentMediaList.value[index].picId
    setBigCurrent(viewer, id, currentMediaList.value[index])
  }
}

export function mediaSwitch ({ index, fileType, subFileType }) {
  const id = currentMediaList.value[index].picId
  setBigCurrent(viewer, id, currentMediaList.value[index])
}

/**
 * 设置场景预渲染事件监听器
 *
 * @param {HTMLElement} dom - 图片元素DOM节点
 * @param {Object} postion - 位置信息对象，包含经纬高等坐标数据
 */
function setScenePreRender (dom, postion) {
  const cartesian2 = new Cesium.Cartesian2()
  Fun = () => setImageViewStyle(dom, postion, cartesian2)
  viewer.scene.preRender.addEventListener(Fun)
}
export function setImageViewStyle (dom, position, cartesian2) {
  const degrees = Cesium.Cartesian3.fromDegrees(position.lng, position.lat, position.alt)
  const now = viewer.scene.cartesianToCanvasCoordinates(degrees, cartesian2)
  if (now) {
    dom.style.top = `${now.y - 500}px`
    dom.style.left = `${now.x - 300}px`
  }
}
export function changeImageView (id) {
  const entity = viewer.entities.getById(id)
  if (!entity) { return }
  const position = entity.position._value
  const cartesian = Cesium.Cartographic.fromCartesian(position)
  const height = viewer.camera.positionCartographic.height
  const nowHeight = cartesian.height
  const customHeight = height - nowHeight
  const frust = {
    heading: Cesium.Math.toDegrees(viewer.camera.heading),
    pitch: Cesium.Math.toDegrees(viewer.camera.pitch),
    roll: Cesium.Math.toDegrees(viewer.camera.roll)
  }

  if (frust.pitch >= -10 || customHeight <= 200) {
    const longitude = Cesium.Math.toDegrees(cartesian.longitude)
    const latitude = Cesium.Math.toDegrees(cartesian.latitude) - 0.0011
    const now_height = cartesian.height
    const new_position = Cesium.Cartesian3.fromDegrees(longitude, latitude, now_height + 100)
    if (!new_position) { return }
    viewer.camera.flyTo({
      destination: new_position,
      orientation: {
        heading: Cesium.Math.toRadians(0),
        pitch: Cesium.Math.toRadians(-30),
        roll: 0
      },
      duration: 1
    })
    return
  }

  const globalHeight = viewer.scene.globe.getHeight(cartesian)
  const f = height - globalHeight
  let heading = 0
  let w = 0.1

  if (frust.pitch > -85 && frust.pitch < 0) {
    const longitude = Cesium.Math.toRadians(90 + frust.pitch)
    let latitudeRatio = 0.6
    if (customHeight > 200) {
      latitudeRatio = 0.4
    }
    w = Math.tan(longitude) * Math.abs(f) / 1000 * latitudeRatio
    heading = frust.heading - 180
  } else if (frust.pitch <= -85) {
    w = 0.2 * f / 1000
    if (frust.heading >= 0 && frust.heading <= 180) {
      heading = frust.heading
    } else if (frust.heading > 180 && frust.heading <= 360) {
      heading = frust.heading - 360
    }
  }

  const S = Cesium.Math.toDegrees(cartesian.longitude)
  const M = Cesium.Math.toDegrees(cartesian.latitude)
  const $ = point([S, M])
  const v = destination($, w, heading, {
    units: 'kilometers'
  })
  const T = v.geometry.coordinates[0]
  const U = v.geometry.coordinates[1]
  const E = Cesium.Cartesian3.fromDegrees(T, U, height)

  if (E) {
    viewer.camera.flyTo({
      destination: E,
      orientation: {
        heading: Cesium.Math.toRadians(frust.heading),
        pitch: Cesium.Math.toRadians(frust.pitch),
        roll: 0
      },
      duration: 1
    })
  }
}
export function closeCurrentMedia () {
  showImageModal.value = false
  if (Fun) {
    viewer?.scene.preRender.removeEventListener(Fun)
    Fun = null
  }
}
function getClass (str) {
  switch (str) {
    case 'normal':
      return new Cesium.NearFarScalar(1e3, 1, 5e5, 0.4)
    case 'big':
      return new Cesium.NearFarScalar(1e3, 1.2, 5e5, 0.6)
  }
}
